<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <MultiselectCustom
                    label="Estado"
                    name="Estado"
                    placeholder="Estado"
                    option-label="nombre"
                    track-by="id"
                    :options="estados"
                    :multiple="false"
                    :allow-empty="false"
                    v-model="data.status"
                />
            </b-col>            <b-col cols="12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="data.name" />
            </b-col>
            <b-col cols="12">
                <b-form-group>
                    <label for="nombre">Descripcion</label>
                    <CkEditorComponent v-model="data.description"/>
                </b-form-group>                    
            </b-col>
            <b-col cols="12">
                <div class="text-center" v-if="data.image">
                    <template>
                        <br/>
                        <img :src="data.image" style="max-height: 200px"/>
                        <br/>
                        <Button class="mt-3" @click="imagenBorrada()">Borrar</Button>
                    </template>
                </div>
                <template v-else>
                    <label for="imagen">Imagen del pack <b>(MEDIDAS: 1020X340 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB)</b></label>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="340"
                        :width="1020"
                        @success="imagenSubida"
                    />
                </template>
            </b-col>
            <b-col cols="12 mt-3">
                <b-form-group>
                    <Provincias :provincia="data.provincia_id" :errors="errors" v-on:selected="selectedOption => { data.provincia_id = selectedOption }"/>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group>
                    <Locations :provincia="data.provincia_id" :location_id="data.location" :errors="errors" v-on:selected="selectedOption => data.location_id = selectedOption"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" v-if="show_address">
                <FormInput label="Dirección" type="text" name="dirección" id="address" rules="required" v-model="data.address" />
            </b-col>
            <b-col cols="12">
                <ValidationProvider name="paises" id="paises" rules="required" v-slot="{ errors }">
                    <label for="recinto">Debe seleccionar el recinto, para poder publicarlo con numeración de butacas.</label>
                    <multiselect
                        v-model="data.recinto"
                        placeholder="Recinto"
                        label="name"
                        track-by="id"
                        :options="recintos"
                        :multiple="false"
                        v-on:select="(selectedOpt) => changeAddress(selectedOpt.address)"
                    />
                    <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12 mt-3">
                <b-btn type="submit">Continuar</b-btn>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import Dropzone from '@/components/common/Dropzone';
    import Provincias from '@/components/common/forms/Provincias';
    import Locations from "@/components/common/forms/Locations";
    import MultiselectCustom from '@/modules/ui/MultiselectCustom.vue';

    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public',
                errors: [],
                recintos: [],
                show_address: true,
                estados: [
                    {id: 0, nombre: 'Borrador'},
                    {id: 1, nombre: 'Publicado'},
                    {id: 3, nombre: 'Aplazado'},
                    {id: 2, nombre: 'Cancelado'},
                ],
            }
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        created() {
            this.getRecintos();

            if(this.data.status) {
                let estadoIndex = this.estados.findIndex(estados => estados.id == this.data.status);
                if(estadoIndex < 0) estadoIndex = 0;
                
                this.data.status = this.estados[estadoIndex];
            } else {
                this.data.status = this.estados[0];
            }
            
            if(this.data.provincia) {
                this.data.provincia_id = this.data.provincia;
            }

            if(this.data.location) {
                this.data.location_id = this.data.location;
            }

            if(!this.data.recinto){
                this.data.recinto = this.recinto || '';
            }

            this.data.pack_id = this.data.id;
        },
        methods: {
            imagenBorrada() {
                this.data.image = '';
            },
            imagenSubida(file, response) {
                this.data.image = response;
            },
            getRecintos() {
                this.$store.dispatch(this.config.getVuexAlias('recintos.index')).then(res => {
                    this.recintos = res.data.data;
                });
            },
            changeAddress(address) {
                this.show_address = false;
                this.data.address = address;
                this.$nextTick(() => this.show_address = true);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.data.location_id = this.data.location_id.id ?? 0;
                    this.data.recinto ? this.data.place_id = this.data.recinto.id : this.data.recinto_id = null;
                    this.data.status = this.data.status.id;
                    this.$emit('terminado');
                }
            },
        },
        components: {
            CkEditorComponent, Dropzone, Provincias, Locations, MultiselectCustom
        }
    }
</script>